let idCounter = 0;

export function getNextId() {
	return `section-${++idCounter}`;
}
